import { tracking } from 'aa/vue/services/Tracking';
import { FLOW_TYPE } from 'aa/vue/models/FlowModel';

export default class Step {
    static pageAttrsNeedUpdate = false;
    postponeTrackStep = false;

    setProps(value) {
        this.props = value;
    }

    set store(value) {
        this._store = value;
    }
    path;
    name;
    nameForTracking;
    component;
    props = {};
    requireAuth;
    requireNonAuth;
    requireSub;
    allowGhost; // set to bypass requireNonAuth for ghost user. No need to set otherwise.
    hideSignInLink;
    hideSignUpLink;
    stepIndex;
    _store;
    countStep = false; // set to true if should be counted in Steps header, e.g. Step 1 of 3

    async beforeEnter(to, from, next) {
        // landing redirect
        if (!window.location.pathname.includes(this.path))
            Step.pageAttrsNeedUpdate = true;

        this._store.commit('setNavFrom', from);

        try {
            await this.checkAccess(from);
            this._store.commit('flow/setCurrentStep', this.stepIndex);
            this.enterRoute(to, from, next);
            this._store.dispatch('notification/showOnlyOnXNumPages');
        } catch (redirect) {
            if (redirect) {
                Step.pageAttrsNeedUpdate = true;

                // If there are query params, maintain them in this redirect
                if (document.location.search !== '') {
                    const queryParams = new URLSearchParams(
                        document.location.search
                    );
                    const entries = queryParams.entries();
                    let queryObj = {};

                    for (const [key, value] of entries) {
                        queryObj[key] = value;
                    }

                    if (typeof redirect === 'string') {
                        redirect = {
                            path: redirect
                        };
                    }

                    redirect.query = queryObj;
                }
                next(redirect);
            }
        }
    }

    /**
     * @param to
     * @param from
     * @param next
     */
    enterRoute(to, from, next) {
        this.getPageAttributes(to, from);
        if (this.postponeTrackStep !== true) {
            this.trackStep(to);
        }

        next();
    }

    /**
     * @param to
     */
    trackStep(to) {
        tracking.trackState(this.getTrackingArgs(to));
    }

    /**
     * @param to
     * @returns {{path: *, name: *}}
     */
    getTrackingArgs(to) {
        let args = {
            name: this.nameForTracking || this.name,
            path: this.path
        };

        if (this._store.getters['flow/type'] === FLOW_TYPE.CBS_SPORTS) {
            args.code_sports = sessionStorage.getItem('cbssc');
        }

        if (this._store.getters.bundleShowtime) {
            args.partnerBundle = 'showtime';
        }
        
        // user state tracking
        Object.assign(args, this._store.state.user.tags)

        return args;
    }

    getPageAttributes(routeTo, routeFrom) {
        if (routeFrom.name) Step.pageAttrsNeedUpdate = true;

        let flowTag = this.getFlowTag();
        let pageName = routeTo.name
            ? 'page_' + routeTo.name.toLowerCase()
            : undefined;

        if (Step.pageAttrsNeedUpdate) {
            this._store.dispatch('pageAttributes/loadPageAttributes', {
                flowType: flowTag,
                name: pageName
            });
        }

        Step.pageAttrsNeedUpdate = true;
    }

    /**
     * @returns {string}
     */
    getFlowTag() {
        let flowType = this._store.getters['flow/type'] || '';

        // use flow type as campaign tag
        if (flowType.indexOf('campaign_') === 0) {
            return flowType;
        }

        // normalize flow tag
        return 'flow_' + flowType.replace('f-', '');
    }

    /**
     * @param from Sends user away if needs to redirect
     * @returns {Promise<unknown>}
     */
    checkAccess(from) {
        return new Promise(async (resolve, reject) => {
            try {
                if (this.requireNonAuth || this.requireAuth) {
                    await this._store.dispatch('user/setUserData');
                }

                if (
                    this.requireNonAuth &&
                    this._store.state.user.isLoggedIn &&
                    !this.isGhostAndAllowed()
                ) {
                    reject(
                        this._store.getters['flow/getFirstStepForAuth'].path
                    );
                    return;
                } else if (
                    this.requireAuth &&
                    !this._store.state.user.isLoggedIn
                ) {
                    reject(
                        this._store.getters['flow/getFirstStepForNonAuth'].path
                    );
                    return;
                }

                let redirect = this.checkFlowRedirect(from);

                if (redirect) {
                    reject(redirect);
                }
            } catch (err) {
                /* Swallow Error, until have handler requirement */
                //setUserData.catch', err)
            }

            resolve();
        });
    }

    /**
     * @param from
     * @returns {null}
     */
    checkFlowRedirect(from) {
        return null;
    }

    /**
     * @returns {boolean|*}
     */
    isGhostAndAllowed() {
        return (
            this._store.state.user.isGhost &&
            (!this.requireNonAuth || this.allowGhost)
        );
    }

    getRoute() {
        return {
            name: this.name,
            path: this.path,
            component: this.component,
            props: this.props,
            beforeEnter: this.beforeEnter.bind(this),
            meta: {
                hideSignInLink: this.hideSignInLink === true,
                hideSignUpLink:
                    this.hideSignUpLink === true ||
                    this._store.getters['flow/isRendezvous']
            }
        };
    }
}
